import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import NProgress from 'nprogress';

const PrivateRoute = ({ children }) => {
  const { isAuthenticated, loading } = useContext(AuthContext);
  
  if (loading) {
    NProgress.start();
    return (
      <div className="flex h-screen items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="inline-block relative w-20 h-20">
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="w-16 h-16 border-4 border-indigo-500 border-t-transparent rounded-full animate-spin"></div>
            </div>
            <svg 
              className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-8 h-8 text-indigo-600" 
              fill="none" 
              viewBox="0 0 24 24"
            >
              <path 
                stroke="currentColor" 
                strokeLinecap="round" 
                strokeLinejoin="round" 
                strokeWidth="2" 
                d="M8 7v8a1 1 0 001 1h6m0 0v3m0-3h-6m6-10v3m0 0h-6m6 0H9"
              />
            </svg>
          </div>
          <p className="mt-4 text-lg font-medium text-gray-700">Please, wait...</p>
          <p className="mt-2 text-sm text-gray-500">Please, wait a moment!</p>
        </div>
      </div>
    );
  }
  
  NProgress.done();
  return isAuthenticated ? children : <Navigate to="/login" />;
};

export default PrivateRoute;